export function getAllCitiesList() {
  return window.__TGV_SEARCH__LOCATIONS_GROUPED.reduce((mem, group) => {
    mem = [...mem, ...group.locations];
    return mem;
  }, []);
}

export function getInitialLocationForCountry() {
  if (!window.__TGV_SEARCH__DEFAULT_LOCATION_ID) {
    return null;
  }

  return getAllCitiesList().filter(city => {
    return city.data.locationId === window.__TGV_SEARCH__DEFAULT_LOCATION_ID;
  })[0];
}

export function getInitialLocationWithGeo() {
  return new Promise((resolve) => {
    $.get('/geolocate').then((data) => {
      const foundCity = getAllCitiesList().find(city => {
        return city.value === data.city;
      });

      resolve(foundCity);
    });
  });
}

export function setInitialLocation($input) {
  return new Promise((resolve) => {
    getInitialLocationWithGeo().then((city) => {
      const initialLocation = city ?? getInitialLocationForCountry();
      $input.val(initialLocation?.value ?? null);
      resolve(initialLocation);
    });
  });
}
